// extracted by mini-css-extract-plugin
export default {"image":"PrivateRoute_image__U2Fx+","title":"PrivateRoute_title__URzmc","content":"PrivateRoute_content__DOnCZ"};